import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import { TSymbolProp, withLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';

class TreeErrorNode extends React.PureComponent {
  render() {
    return (
      <div className="TreeNode TreeNode--error">
        <span>
          {this.props.errorLoadingNodeText ||
            this.props[TSymbolProp].translate('ERROR_LOADING_NODE')}
        </span>
        <Button
          styleType={Button.StyleType.LINK}
          className="TreeNode__try-again"
          onClick={this.props.onTryAgain}
          data-testid={this.props.dataTestid}
        >
          {this.props[TSymbolProp].translate('TRY_AGAIN')}
        </Button>
      </div>
    );
  }
}

TreeErrorNode.propTypes = {
  onTryAgain: PropTypes.func.isRequired,
  errorLoadingNodeText: PropTypes.string,
  dataTestid: PropTypes.string
};

export default TreeErrorNode;

export const TreeErrorNodeWithLocale = withLocale(
  TreeErrorNode,
  ({ locale }) => new MDText(require(`./i18n/${locale}.json`))
);
